import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { BaseModal } from "../../../../../models/basics/basics.models";
import { RoleModel, GetRolesRequest } from "../../../../../models/manage/roles.models";
import { CustomerRoles } from "../steps/roles/roles";
import { CloneHelper } from "@rightship-tech/common-ui/helpers/clone.helper";
import { autoinject } from "aurelia-framework";
import { CustomerService } from "../../../../../services/modules/customer-client.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { ManageRolesClientService } from "../../../../../services/manage/manage-roles.service";
import { I18N } from "aurelia-i18n";
import { ValidationsClientService } from "../../../../../services/validations/validations-client.service";

@autoinject
export class CloneRoleDialog extends BaseModal {
    dataModel: RoleModel;
    view: CustomerRoles;
    title: string;

    constructor(dialogClient: DialogClientService, private customerService: CustomerService, private notificationService: NotificationClientService,
        private manageRolesClientService: ManageRolesClientService, private i18N: I18N,
        private validationsClientService: ValidationsClientService) {
        super(dialogClient);
    }

    activate(args: { view: CustomerRoles, id: number }) {
        this.view = args.view;
        this.title = "Clone Role";
        this.loadRole(args.id);
    }

    loadRole(id: number) {
        return new Promise<void>((resolve) => {
            this.manageRolesClientService.getRoles(<GetRolesRequest>{ roleId: id }).then(x => {
                this.dataModel = CloneHelper.clone(x.roles[0]);
                this.dataModel.roleName = this.dataModel.roleName + " (Clone)";
                resolve();
            });
        });
    }

    onCancel(): Promise<void> {
        return new Promise((resolve) => {
            this.hideModal();
            resolve();
        });
    }

    public async cloneRole() {
        try {
            await this.customerService.cloneRole({
                branchId: this.view.branchId,
                roleId: this.dataModel.roleId,
                roleDescription: this.dataModel.description,
                roleName: this.dataModel.roleName
            });

            this.view.reload();
            this.notificationService.show(this.i18N.tr('changes-saved-successfully-text'), "", NotificationType.Success, 3000);
            this.dialogClient.hide();
        }
        catch (err) {
            if (err.validationResult && err.validationResult.hasError) {
                this.validationsClientService.showValidationErrors(err.validationResult);
            } else {
                this.notificationService.show(this.i18N.tr('error-updating-text'), '', NotificationType.Error, 3000);
            }
            //else it is already handled
        }
    }

    close() {
        this.dialogClient.hide();
    }
}